import React from "react";
import { useLocation } from "react-router-dom";
import MenuApp from "menu/menu-app";

const Header = () => {
    const location = useLocation();

    return (<header>
        <div id="root" data-site="business">
            <MenuApp location={location} />
        </div>
    </header>);
}
export default Header
